import { styled } from '@mui/material';
import Typography from '@mui/material/Typography';

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  display: 'flex',
  fontSize: 12,
  margin: '-8px 2px 10px',
  color: theme.palette.error.main
}));
